/**
 * Created by zhaoyue on 2019-03-31 21:18
 * 获取jwt
 * 首先引入 jsrsasign-latest-all-min.js
 * oPayload中增加nonce字段，规则是项目名+10位随机字符串，例如nonce:app5_9AVL2023UU
 */
function randomStr(n) {
    let res = ''
    for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) {
    }
    return res.substr(0, n)
}

export default function getJwtSafeCode() {
    const iat = Math.floor(new Date().getTime() / 1000)
    let iss = '', sec = ''
    switch (process.env.NODE_ENV) {
        case 'production' :
            // 生产环境网关配置
            iss = '9wGa0Wyip4Q7BDNdC4d4J0eCmUXTZ1ZO'
            sec = 'iOWORRnA1sJ7peVTFk72FgKwmuWHKDPQ'
            break;
        case 'pre' :
            // 预发布环境网关配置
            iss = 'G3FByOaFJyIdFmZspWePZEF54Mcj2sfP'
            sec = 'JZBEuJoNm1ggR3SfgqQK1t5QUiHNSiVJ'
            break;
        case 'testing' :
        case 'dev' :
            // 测试环境网关配置
            // iss = '79rCnwu5W2wrAO3oAcDoLnf0nQJVe6X1'
            // sec = 'Dpkky6CgXHIDW1KNFvvfPam3kIY6Hv1u'
            // 测试环境没有开jwt校验，此jwt匹配预发布环境的upload接口
            iss = 'G3FByOaFJyIdFmZspWePZEF54Mcj2sfP'
            sec = 'JZBEuJoNm1ggR3SfgqQK1t5QUiHNSiVJ'
            break;
        default:
            // 没有匹配到具体环境的按照生产环境网关配置
            iss = '9wGa0Wyip4Q7BDNdC4d4J0eCmUXTZ1ZO'
            sec = 'iOWORRnA1sJ7peVTFk72FgKwmuWHKDPQ'
    }
    const oHeader = {
        alg: 'HS256',
        typ: 'JWT',
    }
    let nonce = 'App5_' + randomStr(10)
    const oPayload = {
        iss: iss,
        iat: iat,
        nbf: iat - 5,
        exp: iat + 60,
        nonce: nonce,
    }
    var sHeader = JSON.stringify(oHeader)
    var sPayload = JSON.stringify(oPayload)
    var safeCode = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, sec)
    safeCode = 'GoFunBearer ' + safeCode
    sessionStorage.jwtSafeCode = safeCode
    window.jwtSafeCode = safeCode
    return safeCode
}



// WEBPACK FOOTER //
// src/libs/http/jwt.js